import { App } from '../app';
import { AuthRoute } from '../Modules/Auth/routes/auth.route';
import User from '../Modules/Auth/models/auth.model';
import Role from '../Modules/Role/models/role.model';
import Labour from '../Modules/Labour/models/labour.model';
import { connectDatabase } from '../database/index';
import mongoose, { Types } from 'mongoose';
import { hashPassword } from '../utils/helpers/utilities.services';
import {  RolesEnum, StatusEnum } from '../Modules/Auth/interfaces/auth.interface';
import { AvailableStatusEnum } from '../Modules/Labour/interfaces/labour.interface';

describe('User Seeding Test', () => {
    let app: App;

    // const inviteStatusMap: { [key in InviteStatusValue]: string } = {
    //     [InviteStatusEnum.WAITING_TO_ACCEPT]: 'Waiting to accept invite',
    //     [InviteStatusEnum.ACCEPTED]: 'Active',
    //     [InviteStatusEnum.Rejected]: 'Inactive',
    // };
    const firstNames = [
        'John', 'Emma', 'Michael', 'Sarah', 'David', 'Lisa', 'James', 'Emily', 'Robert', 'Rachel',
        'William', 'Anna', 'Thomas', 'Sophie', 'Daniel', 'Olivia', 'Matthew', 'Isabella', 'Andrew', 'Grace',
    ];
    const lastNames = [
        'Smith', 'Johnson', 'Brown', 'Taylor', 'Wilson', 'Davis', 'Clark', 'Lewis', 'Walker', 'Hall',
        'Allen', 'Young', 'King', 'Scott', 'Green', 'Adams', 'Baker', 'Nelson', 'Mitchell', 'Perez',
    ];

    const getRandomName = () => `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
    const getRandomFirstName = () => firstNames[Math.floor(Math.random() * firstNames.length)];
    const getRandomLastName = () => lastNames[Math.floor(Math.random() * lastNames.length)];

    // Function to generate a unique email based on first name
    const generateEmail = (firstName: string, lastNameInitial: string, index: number, rolePrefix: string) => {
        const baseEmail = `${firstName.toLowerCase()}${lastNameInitial.toLowerCase()}${index}@ninjatechnolabs.com`;
        return baseEmail;
    };

    beforeAll(async () => {
        await connectDatabase();
        app = new App([new AuthRoute()]);
    }, 20000);

    afterAll(async () => {
        await new Promise((resolve) => app.httpServer.close(resolve));
        if (mongoose.connection.readyState) {
            await mongoose.connection.close();
        }
    }, 10000);

    it('should seed Admin, Staff, and Labour users', async () => {
        const session = await mongoose.startSession();
        session.startTransaction();
        console.log('⏳ Starting user seeding test...');

        try {
            // Fetch roles
            const adminRole = await Role.findOne({ name: { $regex: `^${RolesEnum.ADMIN}$`, $options: 'i' } }).session(session);
            const staffRole = await Role.findOne({ name: { $regex: `^${RolesEnum.STAFF}$`, $options: 'i' } }).session(session);
            const labourRole = await Role.findOne({ name: { $regex: `^${RolesEnum.LABOUR}$`, $options: 'i' } }).session(session);

            if (!adminRole || !staffRole || !labourRole) {
                throw new Error('Required roles not found');
            }

            const admins: mongoose.Document[] = [];
            const adminNames = [
                'John Smith', 'Emma Johnson', 'Michael Brown', 'Sarah Taylor', 'David Wilson',
            ];
            for (let i = 0; i < 5; i++) {
                const [firstName, lastName] = adminNames[i].split(' ');
                const passwordHash = await hashPassword('AdminNinja@123');
                const admin = new User({
                    email: generateEmail(firstName, lastName[0], i + 1, 'admin'),
                    fullName: adminNames[i],
                    joiningDate: new Date(),
                    roleId: adminRole._id,
                    firstName,
                    lastName,
                    // inviteStatus: Object.values(InviteStatusEnum)[Math.floor(Math.random() * 3)] as InviteStatusValue,
                    invitedAt: new Date(),
                    acceptedInviteAt: new Date(),
                    isDeleted: false,
                    deletedAt: null,
                    status: StatusEnum.ACTIVE,
                    accountSetting: {
                        passwordHash,
                        userName: `${firstName.toLowerCase()}${lastName.toLowerCase()}`,
                    },
                });
                await admin.save({ session });
                admins.push(admin);
            }

            const staff: mongoose.Document[] = [];
            for (let i = 0; i < 22; i++) {
                const fullName = getRandomName();
                const [firstName, lastName] = fullName.split(' ');
                const passwordHash = await hashPassword('StaffNinja@123');
                const randomAdmin = admins[Math.floor(Math.random() * admins.length)];


                const staffUser = new User({
                    email: generateEmail(firstName, lastName[0], i + 1, 'staff'),
                    fullName,
                    joiningDate: new Date(),
                    roleId: staffRole._id,
                    firstName,
                    lastName,
                    // inviteStatus: Object.values(InviteStatusEnum)[Math.floor(Math.random() * 3)] as InviteStatusValue,
                    invitedAt: new Date(),
                    // acceptedInviteAt: inviteStatusMap[InviteStatusEnum.ACCEPTED] === 'Active' ? new Date() : null,
                    isDeleted: false,
                    deletedAt: null,
                    status: StatusEnum.ACTIVE,
                    createdBy: randomAdmin._id,
                    accountSetting: {
                        passwordHash,
                        userName: `${firstName.toLowerCase()}${lastName.toLowerCase()}`,
                    },
                });
                await staffUser.save({ session });
                staff.push(staffUser);
            }

            const labours: mongoose.Document[] = [];
            for (let i = 0; i < 32; i++) {
                const fullName = getRandomName();
                const [firstName, lastName] = fullName.split(' ');
                const passwordHash = await hashPassword('LabourNinja@123');
                const randomStaff = staff[Math.floor(Math.random() * staff.length)];
                const labourUser = new User({
                    email: generateEmail(firstName, lastName[0], i + 1, 'labour'),
                    fullName,
                    joiningDate: new Date(),
                    roleId: labourRole._id,
                    firstName,
                    lastName,
                    // inviteStatus: Object.values(InviteStatusEnum)[Math.floor(Math.random() * 3)] as InviteStatusValue,
                    invitedAt: new Date(),
                    // acceptedInviteAt: inviteStatusMap[InviteStatusEnum.ACCEPTED] === 'Active' ? new Date() : null,
                    isDeleted: false,
                    deletedAt: null,
                    status: StatusEnum.ACTIVE,
                    createdBy: randomStaff._id,
                    accountSetting: {
                        passwordHash,
                        userName: `${firstName.toLowerCase()}${lastName.toLowerCase()}`,
                    },
                });
                await labourUser.save({ session });
                labours.push(labourUser);

                const labourDoc = new Labour({
                    userId: labourUser._id,
                    employee_id: `LBR-${(i + 1).toString().padStart(4, '0')}`,
                    availability_status: AvailableStatusEnum.AVAILABLE,
                });
                await labourDoc.save({ session });
            }

            await session.commitTransaction();
            console.log('Seeding completed successfully!');
        } catch (error) {
            await session.abortTransaction();
            console.error('Seeding failed:', error);
            throw error;
        } finally {
            session.endSession();
        }
    }, 60000);
});
